import React from 'react';

export const KeyboardReturn = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_138_12307"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect
        x="0.600098"
        y="0.443359"
        width="20"
        height="20"
        fill={color || '#7D7A9A'}
      />
    </mask>
    <g mask="url(#mask0_138_12307)">
      <path
        d="M8.1001 15.4434L3.1001 10.4434L8.1001 5.44336L9.26676 6.61003L6.26676 9.61003H16.4334V6.27669H18.1001V11.2767H6.26676L9.26676 14.2767L8.1001 15.4434Z"
        fill={color || '#7D7A9A'}
      />
    </g>
  </svg>
);
